import React, {forwardRef} from 'react';
import ModalTemplate from "../../Wrappers/ModalTemplate";
import FormInput from "../../Atoms/Templates/FormInput";
import Select from "../../Atoms/Forms/Select";
import DatePickerInput from "../../Molecules/Pickers/DatePickerInput";
import TextArea from "../../Atoms/Forms/TextArea";
import AddButton from "../../Atoms/Buttons/AddButton";
import DischargedEmployee from "../../Molecules/DischargedEmployee";
import SelectEmployeeInput from "../../Molecules/Selects/SelectEmployeeInput";

const SettlementModal = forwardRef((props, ref) => {
  const { handleCloseModal } = props

  return (
    <ModalTemplate ref={ref}>
      <h3 className="s-center">Liquidación de contrato</h3>
      <form
        action="#"
        className="ed-grid form-grid s-mb-0">
        <SelectEmployeeInput />
        <div className="ed-grid m-grid-2">
          <Select label="Motivo de terminación"
            isRequired
            placeholder>
            <option value="male">Motivo 1</option>
            <option value="female">Motivo 2</option>
            <option value="undefined">Motivo 3</option>
          </Select>

          <DatePickerInput label="Último día de trabajo"
            isRequired/>
        </div>

        <TextArea
          label="Detalles de la liquidación"
        />

        {/* Lista de empleados para liquidar */}
        <div className="ed-grid">
          <DischargedEmployee/>
        </div>

        {/* Botón para agregar más empleados*/}
        <div className="s-main-center">
          <AddButton onClick={() => {
          }}
            text="Agrega a otro empleado"/>
        </div>

        {/* Botones para cancelar o liquidar*/}
        <div className="buttons-container">
          <button onClick={handleCloseModal}
            className="button cancel">Cancela
          </button>
          <button className="button">Liquida a los empleados</button>
        </div>
      </form>
    </ModalTemplate>
  );
})

export default SettlementModal;
